<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <!--家长管理-->
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="parentName" placeholder="家长姓名" clearable></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="studentName" placeholder="学生姓名" clearable></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="phone" placeholder="联系电话" clearable></el-input>
                </div>
            </div>
            <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>

            <el-table
                :data="data"
                style="width:100%;margin-bottom:20px;"
                row-key="id"
                height="550"
                border
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255,255,0.7)"
                default-expand-all>
                <el-table-column type="index" fixed label="序号" width="55px" :index="indexMethod"> </el-table-column>
                <el-table-column prop="parentName" label="家长姓名" min-width="120" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="studentName" label="学生姓名" min-width="120" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="phone" label="联系电话" min-width="140" :show-overflow-tooltip="true"></el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        name:"ParentManage",
        data(){
            return{
                loading:false,
                loadingText:"",
                menuName:"",
                data:[],
                depts:[],
                deptId: "",
                parentName:"",
                studentName:"",
                phone:"",
                common:{
                    total:0,
                    pageSize:30,
                    page:1,
                    isPage:1,
                    allSizes:[30,50,100],
                }
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                this.loadingText="数据加载中...";

                let url  = this.parentManageUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    parentName:this.parentName,
                    studentName:this.studentName,
                    phone:this.phone,
                    deptId:this.deptId
                };
                
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        // 兼容两种常见返回结构：{list,total} 或 {data,total}
                        this.data = res.data.list || res.data.data || [];
                        this.common.total = res.data.total || 0;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/page/sys/parent/Parent.vue